<template>
    <div class="cubeSpace final_efisense w-100">
        <section class="medidas_efisense d-flex w-100">

            <section class="seccion-final_footer">
                <div class="seccion-logo_footer">
                    <img :src="a3" class="logo">
                </div>

                <div class="seccion-footer_h2">
                    <h2 class="fuente-nova">Diseñamos experiencias exepcionales para marcas lideres que buscan una
                        conexión auténtica con sus clientes.
                    </h2>
                </div>


                <div class="seccion_enlaces mt-3">

                    <a href="https://efisense.com" target="_blank" class="linkAccess fuente-nova">efisense.com</a>

                    <a href="mailto:hola@efisense.com" class="linkAccess fuente-nova">hola@efisense.com</a>

                    <a href="tel:+529999306053" target="_blank" class="fuente-nova linkAccess">+52 (999) 930.60.53</a>
                </div>

                <div class="seccion_redes mt-4">
                    <a href="https://www.facebook.com/efisense" class="" target="_blank">
                        <img :src="a30" class="socialSvg">&nbsp;&nbsp;&nbsp;Facebook
                    </a>

                    <a href="https://www.instagram.com/efisense/" class="mt-3" target="_blank">
                        <img :src="a29" class="socialSvg">&nbsp;&nbsp;&nbsp;Instagram
                    </a>

                    <a href="https://wa.me/529996435584" class="mt-3" target="_blank">
                        <img :src="a47" class="socialSvg">&nbsp;&nbsp;&nbsp;WhatsApp
                    </a>

                </div>

                <div class="seccion-footer_h3">
                    <h2 class="fuente-nova">Efisense Media, Tablaje 33796 Calle 34 S/N, Komchén, Mérida, YUC 97302,
                        Mexico
                    </h2>
                </div>
            </section>

            <section class="seccion-dinamica_footer">

                <article v-for="section in landings" class="article_footer" :style="`justify-content: ${ landings.length > 1 ? 'flex-start' : 'space-evenly' }`">
                    <h2 class="fuente-nova2">{{ section.name }}</h2>
                    <p v-for="landing in section.landings" class="fuente-nova" @click="pushLanding(landing)">{{ landing.name }}</p>
                    <template v-if="section.subs.length > 0">
                        <article v-for="subSection in section.subs" class="article_footer">
                            <h2 class="fuente-nova2">{{ subSection.name }}</h2>
                            <p v-for="landing in subSection.landings" class="fuente-nova" @click="pushLanding(landing)">{{ landing.name }}</p>
                        </article>
                    </template>
                </article>

            </section>

        </section>

    </div>
</template>

<script>
export default {
    name: 'page13',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a3: require('@/assets/images/a46.png'),
            a29: require('@/assets/images/a29.svg'),
            a30: require('@/assets/images/a30.svg'),
            a47: require('@/assets/images/a47.svg'),
            landings: []
        }
    },
    mounted () {
        this.getLandings()
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        },
        getLandings () {
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            fetch('https://mikele.efisen.se/apiCRM/Landing/getList', config)
                .then(response => response.json())
                .then(data => {
                    // console.log('Landings fetched:', data)
                    if (data.code && data.code === 200) {
                        this.landings = data.data
                    } else {
                        this.landings = []
                        console.error('Error fetching landings:', data.message)
                    }
                })
                .catch(error => {
                    console.error('Error fetching landings:', error)
                })
        },
        pushLanding(landing) {
            this.$router.push({ 
                path: `/l/${landing.relativePath}`,
                state: landing
            })
        },
    },
}
</script>
<style lang="css" scoped>
.medidas_efisense {
    display: flex;
    justify-content: space-around;
    max-width: 1800px;
    margin: 0 auto;
    padding: 80px 10px;
}

.final_efisense {
    background-color: #272727 !important;
    /* width: 100%; */
}

.seccion-final_footer {
    max-width: 30%;
    color: white !important;
}

.seccion-final_footer .seccion-logo_footer {
    max-width: 300px;
    margin: 0;
}

.seccion-final_footer .seccion-logo_footer img {
    width: 100%;

}

.seccion-final_footer .seccion-footer_h2 h2 {
    font-size: clamp(5px, 4vw, 20px);
    margin-top: 30px;
    margin-left: 20px;
    margin-right: 20px;
}

.seccion-final_footer .seccion-footer_h3 h2 {
    font-size: clamp(5px, 4vw, 13px);
    margin-top: 30px;
    margin-left: 20px;
    margin-right: 20px;
}


.seccion-final_footer .seccion_enlaces a {
    color: white !important;
    font-size: clamp(5px, 3vw, 12px);
    font-weight: bold;
    margin-top: 30px;
    margin-left: 20px;
    text-decoration: none;
}

.seccion-final_footer .seccion_redes a {
    color: white !important;
    font-weight: bold;
    margin-left: 20px;
    text-decoration: none;
    font-size: clamp(8px, 4vw, 20px);
    display: flex;
    align-items: center;
    justify-content: start;

}

.seccion-final_footer .seccion_redes {
    display: flex;
    flex-direction: column;
}

.seccion-final_footer .seccion_redes img {
    width: 18px;
    height: 18px;
    margin: 0;
}

.seccion-dinamica_footer {
    padding-top: 135px;
    width: 65%;
    display: flex;
    flex-wrap: wrap;
}

.seccion-dinamica_footer .article_footer {
    color: white;
    max-width: 40%;
    margin: 0 20px;
}

.seccion-dinamica_footer .article_footer h2 {
    /* margin-left: 30px; */
    font-weight: 30px;
    font-size: clamp(8px, 5vw, 20px);
}

.seccion-dinamica_footer .article_footer p {
    color: white;
    margin-left: 30px;
    font-size: clamp(8px, 5vw, 15px);
    font-weight: bold;
}

.seccion-dinamica_footer .article_footer p:hover {
    color: gray;
    margin-left: 30px;
    font-size: clamp(8px, 5vw, 15px);
    font-weight: bold;
    cursor: pointer;
}

@media screen and (max-width:550px) {

    .medidas_efisense {
        display: flex;
        flex-direction: column;
    }

    .seccion-final_footer {
        max-width: 100%;
    }

    .seccion-final_footer .seccion-logo_footer {
        max-width: 200px;
        margin: 0;
    }

    .seccion-dinamica_footer {
        width: 100%;
    }

    .seccion-dinamica_footer .article_footer h2 {
        font-size: 15px;
    }

    .seccion-dinamica_footer .article_footer p {
        font-size: 10px;
        margin-left: 15px;
    }


}
</style>